'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import uniqueId from 'lodash/uniqueId';
import Image from 'next/image';
import { cn } from '@src/utils/tailwind';
import { expertGridDefaults } from './ExpertGrid.defaults';
import { type ExpertGridProps } from './ExpertGrid.props';
export const ExpertGrid = t0 => {
  const $ = _c(42);
  const props = t0 === undefined ? expertGridDefaults : t0;
  const {
    backgroundColor,
    columnsDesktop,
    columnsMobile,
    imageAlt,
    experts,
    heading,
    imageSrcDesktop,
    imageRightDesktop,
    imageScaleDesktop,
    imageSrcMobile,
    subheading,
    children,
    childrenPositionDesktop
  } = props;
  let t1;
  if ($[0] !== columnsDesktop || $[1] !== columnsMobile || $[2] !== experts) {
    t1 = () => <div className={cn("grid w-fit shrink-0 place-items-center gap-x-2 gap-y-7 lg:place-items-start lg:gap-8", `lg:grid-cols-${columnsDesktop} grid-cols-${columnsMobile}`)}>{experts?.map(_temp)}</div>;
    $[0] = columnsDesktop;
    $[1] = columnsMobile;
    $[2] = experts;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const renderExpertGrid = t1;
  let t2;
  if ($[4] !== backgroundColor) {
    t2 = {
      backgroundColor
    };
    $[4] = backgroundColor;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = heading ?? "";
  let t4;
  if ($[6] !== t3) {
    t4 = <h4 className="text-heading-display-2 mb-4 lg:mb-6" dangerouslySetInnerHTML={{
      __html: t3
    }} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = subheading ?? "";
  let t6;
  if ($[8] !== t5) {
    t6 = <p className="text-body-base" dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="mb-6 max-w-xl">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = imageSrcMobile ?? "";
  const t9 = imageAlt ?? "";
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      width: "100%",
      height: "auto"
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t8 || $[15] !== t9) {
    t11 = <Image src={t8} alt={t9} sizes="100vw" width={0} height={0} className="mx-auto mt-8 mb-12 max-w-sm lg:hidden" style={t10} />;
    $[14] = t8;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = childrenPositionDesktop === "bottom";
  let t13;
  if ($[17] !== t12) {
    t13 = cn("flex flex-col lg:flex-row", {
      "lg:flex-col": t12
    });
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== renderExpertGrid) {
    t14 = renderExpertGrid();
    $[19] = renderExpertGrid;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== children || $[22] !== props.builderBlock?.id || $[23] !== props.children) {
    t15 = children && <BuilderBlocks parentElementId={props?.builderBlock?.id} dataPath="component.options.children" blocks={props?.children} />;
    $[21] = children;
    $[22] = props.builderBlock?.id;
    $[23] = props.children;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t14 || $[27] !== t15) {
    t16 = <div className={t13}>{t14}{t15}</div>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t11 || $[30] !== t16 || $[31] !== t7) {
    t17 = <div className="col-span-6 px-6 py-9 lg:p-16 xl:col-span-8">{t7}{t11}{t16}</div>;
    $[29] = t11;
    $[30] = t16;
    $[31] = t7;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== imageAlt || $[34] !== imageRightDesktop || $[35] !== imageScaleDesktop || $[36] !== imageSrcDesktop) {
    t18 = imageSrcDesktop && <div className="relative z-10 col-span-6 h-full xl:col-span-4"><Image alt={imageAlt ?? ""} src={imageSrcDesktop} sizes="100vw" width={0} height={0} className="absolute inset-0 hidden origin-bottom-right object-cover lg:block" style={{
        width: "auto",
        height: "100%",
        right: imageRightDesktop,
        scale: imageScaleDesktop
      }} /></div>;
    $[33] = imageAlt;
    $[34] = imageRightDesktop;
    $[35] = imageScaleDesktop;
    $[36] = imageSrcDesktop;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18 || $[40] !== t2) {
    t19 = <div className="relative grid grid-cols-1 rounded-[28px] text-bodi-black-text lg:grid-cols-12" style={t2}>{t17}{t18}</div>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t2;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
};
function _temp(expert) {
  return <div key={uniqueId()} className="w-full max-w-[168px] text-body-md"><Image src={expert.imageSrc ?? ""} alt={expert.imageAlt ?? ""} sizes="100vw" width={0} height={0} className="mb-3" style={{
      width: "100%",
      height: "auto"
    }} />{expert?.name && <h6 className="mb-2 font-medium" dangerouslySetInnerHTML={{
      __html: expert?.name
    }} />}{expert?.description && <p dangerouslySetInnerHTML={{
      __html: expert?.description
    }} />}</div>;
}